export default "__VITE_ASSET__DKlRCUFV__"